(function () {
  var CFG = window.pdmCompare || {};
  var S = CFG.strings || {};
  var KEY = 'pdm_compare';
  var MAX = CFG.max || 4;
  var URL_PAGE = CFG.page || '/pages/porownanie';
  var hidden = [];

  function t(key, fallback, count){
    var s = S[key] || fallback;
    return count === undefined ? s : s.replace('{count}', count);
  }

  function read(){ try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch(e){ return []; } }
  function save(v){ try { localStorage.setItem(KEY, JSON.stringify(v)); } catch(e){} }
  function idx(items, h){ for (var i=0;i<items.length;i++) if (items[i].handle===h) return i; return -1; }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

  var bar, toast;
  function toastMsg(msg){
    if (!toast){ toast = document.createElement('div'); toast.className='pdm-compare-toast'; document.body.appendChild(toast); }
    toast.textContent = msg; toast.classList.add('is-visible');
    clearTimeout(toast._t); toast._t = setTimeout(function(){ toast.classList.remove('is-visible'); }, 2500);
  }

  function renderBar(items){
    if (!bar){
      bar = document.createElement('div');
      bar.className = 'pdm-compare-bar';
      bar.setAttribute('role','region');
      bar.setAttribute('aria-label', t('bar_region','Porownanie'));
      document.body.appendChild(bar);
    }
    if (!items.length){ bar.classList.remove('is-visible'); bar.innerHTML=''; return; }
    var handles = items.map(function(i){ return encodeURIComponent(i.handle); }).join(',');
    var html = '<div class="pdm-compare-bar__inner"><div class="pdm-compare-bar__items">';
    items.forEach(function(it){
      html += '<div class="pdm-compare-bar__item">' +
        (it.image ? '<img src="'+esc(it.image)+'" alt="" width="30" height="30" loading="lazy">' : '') +
        '<span>'+esc(it.title)+'</span>' +
        '<button type="button" data-remove="'+esc(it.handle)+'" aria-label="'+esc(t('remove','Usun'))+'">&times;</button></div>';
    });
    html += '</div><div class="pdm-compare-bar__actions">' +
      '<button type="button" class="pdm-compare-bar__clear" data-clear>'+esc(t('clear','Wyczysc'))+'</button>' +
      '<a class="pdm-compare-bar__cta" href="'+URL_PAGE+'?items='+handles+'">'+esc(t('cta','Porownaj ({count})', items.length))+'</a>' +
      '</div></div>';
    bar.innerHTML = html;
    bar.classList.add('is-visible');
  }

  function markDiffs(table){
    var rows = table.querySelectorAll('tbody tr');
    for (var r=0; r<rows.length; r++){
      var cells = rows[r].querySelectorAll('td[data-handle]');
      var visible = [];
      for (var c=0; c<cells.length; c++){
        cells[c].classList.remove('is-diff');
        if (!cells[c].hidden) visible.push(cells[c]);
      }
      if (visible.length < 2) continue;
      var first = visible[0].textContent.replace(/\s+/g,' ').trim();
      var differs = false;
      for (var v=1; v<visible.length; v++){
        if (visible[v].textContent.replace(/\s+/g,' ').trim() !== first){ differs = true; break; }
      }
      if (differs) for (var k=0; k<visible.length; k++) visible[k].classList.add('is-diff');
    }
  }

  function filterTable(handles){
    var table = document.getElementById('pdm-compare-table');
    if (!table) return;
    var showAll = table.classList.contains('is-showing-all') || handles.length === 0;
    var cells = table.querySelectorAll('[data-handle]');
    var shown = 0;
    for (var i=0; i<cells.length; i++){
      var h = cells[i].getAttribute('data-handle');
      var hide = showAll ? hidden.indexOf(h) > -1 : handles.indexOf(h) === -1;
      cells[i].hidden = hide;
      if (!hide && cells[i].tagName === 'TH') shown++;
    }
    var count = document.querySelector('[data-compare-count]');
    if (count) count.textContent = (showAll && !hidden.length) ? t('all_models','') : t('selected','{count}', shown);
    var btn = document.querySelector('[data-compare-showall]');
    if (btn) btn.hidden = showAll && !hidden.length;
    markDiffs(table);
  }

  function sync(){
    var items = read(), handles = items.map(function(i){ return i.handle; });
    var inputs = document.querySelectorAll('.pdm-compare-input');
    for (var i=0; i<inputs.length; i++){
      var on = handles.indexOf(inputs[i].getAttribute('data-handle')) > -1;
      inputs[i].checked = on;
      var label = inputs[i].closest('.pdm-compare-toggle');
      if (label) label.classList.toggle('is-active', on);
    }
    renderBar(items);
    filterTable(handles);
  }

  function toggle(handle, data, force){
    var items = read(), i = idx(items, handle);
    if (force === false || (force === undefined && i > -1)) {
      if (i > -1) items.splice(i, 1);
    } else if (i === -1) {
      if (items.length >= MAX){ toastMsg(t('limit','{count}', MAX)); sync(); return; }
      items.push(data);
      if (hidden.indexOf(handle) > -1) hidden.splice(hidden.indexOf(handle), 1);
    }
    save(items); sync();
  }

  /* krzyzyk w naglowku tabeli */
  function removeColumn(handle){
    var table = document.getElementById('pdm-compare-table');
    var items = read();
    var i = idx(items, handle);
    var selecting = items.length > 0 && !(table && table.classList.contains('is-showing-all'));

    if (selecting && i > -1){
      items.splice(i, 1);
      save(items);
      if (items.length === 0 && table) table.classList.add('is-showing-all');
    } else if (hidden.indexOf(handle) === -1){
      hidden.push(handle);
      if (i > -1){ items.splice(i, 1); save(items); }
    }
    sync();
  }

  function initFromUrl(){
    var table = document.getElementById('pdm-compare-table');
    if (!table) return;
    var raw = new URLSearchParams(location.search).get('items');
    if (!raw) return;
    var items = [];
    raw.split(',').filter(Boolean).slice(0, MAX).forEach(function(h){
      var handle = decodeURIComponent(h);
      var th = table.querySelector('th[data-handle="' + handle.replace(/"/g,'') + '"]');
      if (!th) return;
      items.push({
        handle: handle,
        title: th.getAttribute('data-title') || handle,
        url: th.getAttribute('data-url') || '',
        image: th.getAttribute('data-image') || ''
      });
    });
    if (items.length) save(items);
  }

  document.addEventListener('change', function(e){
    var input = e.target.closest('.pdm-compare-input');
    if (!input) return;
    toggle(input.getAttribute('data-handle'), {
      handle: input.getAttribute('data-handle'),
      title: input.getAttribute('data-title'),
      url: input.getAttribute('data-url'),
      image: input.getAttribute('data-image')
    }, input.checked);
  });

  document.addEventListener('click', function(e){
    var cell = e.target.closest('.pdm-compare__remove');
    if (cell){ removeColumn(cell.getAttribute('data-remove')); return; }
    var rm = e.target.closest('[data-remove]');
    if (rm){ toggle(rm.getAttribute('data-remove'), null, false); return; }
    if (e.target.closest('[data-clear]')){
      hidden = [];
      var tc = document.getElementById('pdm-compare-table');
      if (tc) tc.classList.add('is-showing-all');
      save([]); sync(); return;
    }
    var all = e.target.closest('[data-compare-showall]');
    if (all){
      hidden = [];
      var tbl = document.getElementById('pdm-compare-table');
      if (tbl) tbl.classList.add('is-showing-all');
      sync();
    }
  });

  document.addEventListener('DOMContentLoaded', function(){ initFromUrl(); sync(); });
})();